import { cn } from '../../../utils/tailwindMerge';
import ToolTip from '../ToolTip';

type TextFieldProps = {
  label?: string;
  type: string;
  placeholder: string;
  value: string | number;
  handleInputChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  id?: string;
  name?: string;
  handleInputOnBlurChange?: (
    event: React.ChangeEvent<HTMLInputElement>
  ) => void;
  classes?: string;
  isRequired?: boolean;
  disable?: boolean;
  toolTipEnable?: boolean;
  toolTipLabel?: string;
  toolTipText?: string;
  toolTipId?: string;
  max?: string;
  min?: string;
};

const TextField = ({
  label,
  type,
  placeholder,
  value,
  handleInputChange,
  id,
  name,
  handleInputOnBlurChange,
  classes,
  isRequired,
  disable,
  toolTipText,
  toolTipLabel,
  toolTipEnable,
  toolTipId,
  max,
  min
}: TextFieldProps) => {
  return (
    <>
      {label && (
        <>
          <label className='my-2 block text-sm font-bold text-gray-700'>
            {label} {isRequired && <span className='mr-2 text-[red]'>*</span>}{' '}
            {toolTipEnable && toolTipId ? (
              <span
                data-tooltip-id={toolTipId}
                data-tooltip-content={toolTipText}
                data-tooltip-place='right'
                className='mt-1 flex h-4 w-4 items-center justify-center rounded-full border border-[#737E93] text-[#737E93]'
              >
                {toolTipLabel}
                <ToolTip id={toolTipId} />
              </span>
            ) : (
              ''
            )}
          </label>{' '}
        </>
      )}
      <input
        className={cn([
          'my-input h-[47px] w-full appearance-none rounded-[8px] border border-[#E3E5E9] bg-[#F5F9FF] px-3 py-2 text-base font-medium leading-tight text-[#202020] focus:outline-none',
          disable && 'cursor-not-allowed',
          classes,
          undefined
        ])}
        id={id}
        type={type}
        placeholder={placeholder}
        value={value}
        onChange={e => handleInputChange(e)}
        onBlur={e => {
          if (handleInputOnBlurChange) {
            handleInputOnBlurChange(e);
          }
        }}
        name={name}
        disabled={disable}
        {...(type === 'number' && max !== undefined ? { max } : {})}
        {...(type === 'number' && min !== undefined ? { min } : {})}
      />
    </>
  );
};

export default TextField;
